import type { FC } from "react";
import { UsersPage } from "./UsersPage";

export { UserDetailPage } from "./UserDetailPage";
export { UsersPage } from "./UsersPage";

const UsersContainer: FC = () => {
  return <UsersPage />;
};

export default UsersContainer;
